import { Typography, Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { ReactNode } from "react"
import { Stack } from "@mui/system"

const useStyles = makeStyles()((theme) => ({
    detailRow: {
        display: "flex",
    },
    detailLabel: {
        color: theme.palette.text.secondary,
        width: "9rem",
        flexShrink: 0,
        lineHeight: "100%",
    },
    detailValue: {
        fontWeight: 500,
        lineHeight: "100%",
        textAlign: "left",
    },
}))

interface DetailRowProps {
    label: string
    value: string | number | ReactNode
    secondaryValues?: ReadonlyArray<string | undefined>
}

export default function DetailRow({ label, value, secondaryValues }: DetailRowProps) {
    const { classes } = useStyles()

    return (
        <Box className={classes.detailRow}>
            <Typography variant="body1" className={classes.detailLabel}>
                {label}
            </Typography>
            <Stack gap="0.25rem">
                <Typography variant="body1" className={classes.detailValue}>
                    {value}
                </Typography>
                {secondaryValues?.filter(Boolean).map((secondaryValue) => (
                    <Typography key={secondaryValue} variant="body1" className={classes.detailValue}>
                        {secondaryValue}
                    </Typography>
                ))}
            </Stack>
        </Box>
    )
}
